//@ts-check
import React from 'react';
import { createStyles, useTheme, makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Grid from '@material-ui/core/Grid';
import cx from 'classnames';
import ToolBarTabs from './Tabs';
import Utils from '../../utils';
import Icon from '../../core/Icon';
import { usePageToolBar } from '../Provider';
var APP_ICON_WIDTH = 48;
var useStyles = makeStyles(function (t) {
  /** @type {import('../../theme/types').EcrionTheme} */
  var theme = t;
  var commonPageStyle = theme.getStyle('Page.Common');
  return createStyles({
    root: {
      width: '100%',
      height: theme.common.Page.ToolBar.style.height,
      backgroundColor: theme.common.Page.ToolBar.style.backgroundColor,
      color: theme.common.Page.ToolBar.style.color,
      paddingRight: theme.spacing(0.25),
      boxShadow: theme.common.Page.ToolBar.style.boxShadow,
      position: 'relative',
      zIndex: '10'
    },
    toolbar: {
      height: '100%',
      '& .material-icons, & .text-button .material-icons': {
        fontSize: '0.875rem'
      }
    },
    iconWrapper: {
      height: theme.common.Page.ToolBar.style.height,
      width: APP_ICON_WIDTH - 6,
      textAlign: 'center',
      marginRight: 6
    },
    leftTextWrapper: {
      maxWidth: "calc(100% - ".concat(APP_ICON_WIDTH, "px)"),
      color: theme.common.Page.ToolBar.style.color
    },
    textWrapper: {
      fontWeight: 'bold',
      color: theme.common.Page.ToolBar.style.color
    },
    left: {
      textAlign: 'left'
    },
    center: {
      textAlign: 'center'
    },
    right: {
      textAlign: 'right'
    },
    fullHeight: {
      height: '100%'
    },
    tab: {
      zIndex: 1,
      textTransform: 'none',
      fontSize: 'inherit',
      fontWeight: 'inherit',

      /** placed over tabIndicator */
      color: commonPageStyle.color ? commonPageStyle.color : theme.palette.getContrastText(commonPageStyle.backgroundColor)
    },
    selectedTab: {
      fontWeight: 600
    },
    tabIndicator: {
      zIndex: 0,
      height: '90%',
      backgroundColor: commonPageStyle.backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius
    }
  });
}, {
  name: 'ECToolbar'
});
/**
 * @param {import('./types').PageToolBarProps} props
 */

var ToolBar = function ToolBar(_ref) {
  var style = _ref.style,
      color = _ref.color,
      icon = _ref.icon,
      leftChildren = _ref.leftChildren,
      centerChildren = _ref.centerChildren,
      centerTabs = _ref.centerTabs,
      rightChildren = _ref.rightChildren;
  usePageToolBar();
  var classes = useStyles({});
  /** @type {import('../../theme/types').EcrionTheme} */

  var theme = useTheme();
  var xs = useMediaQuery(theme.breakpoints.only('xs'));
  var appTheme = theme.getStyle('Page.ToolBar');
  /**@type {import('core/Icon/types').IconProps} */

  var iconProps = {};

  if (icon) {
    if (typeof icon === 'string') iconProps.type = icon;else if (typeof icon === 'object') iconProps = Utils.deepMerge(iconProps, icon);
  }

  if (iconProps.onClick) {
    iconProps.style = iconProps.style || {};
    iconProps.style.fontSize = '1.5rem';
    iconProps.style.color = theme.common.Page.ToolBar.style.color;
    if (!iconProps.label && iconProps.type === 'close') iconProps.label = 'Close';
  }
  /**@type {React.CSSProperties} */


  var rootStyle = {};
  /**@type {React.CSSProperties} */

  var iconWrapperStyle = {};
  if (!icon) iconWrapperStyle.visibility = 'hidden';
  if (iconProps.onClick) iconWrapperStyle.opacity = 0.75;else iconWrapperStyle.opacity = 0.5;
  if (appTheme.backgroundColor) rootStyle.backgroundColor = appTheme.backgroundColor;

  if (color) {
    if (color === 'primary' || color === 'secondary') rootStyle.backgroundColor = theme.palette[color].main;else if (color === 'navbar') rootStyle.backgroundColor = theme.getStyle('Page.NavBar').backgroundColor;
  }

  rootStyle = Utils.deepMerge(rootStyle, style);
  if (rootStyle.backgroundColor) rootStyle.color = theme.palette.getContrastText(rootStyle.backgroundColor);
  var darkAppIconBackground = iconProps.type !== 'close';

  if (darkAppIconBackground) {
    iconWrapperStyle.backgroundColor = darken(rootStyle.backgroundColor, 0.2);
    iconWrapperStyle.color = theme.palette.getContrastText(iconWrapperStyle.backgroundColor);
  }

  var center = centerChildren;
  if (!center && centerTabs) center = React.createElement(ToolBarTabs, Object.assign({
    classes: classes
  }, centerTabs));
  var leftStyle = {};

  if (leftChildren) {
    if (!center && !rightChildren) //two sections missing
      leftStyle.maxWidth = '100%';else if (center && !rightChildren || center && !leftChildren) //one section missing
      leftStyle.maxWidth = '80%';
  }

  if ((centerTabs || centerChildren) && rightChildren && !leftChildren && xs) leftStyle.display = 'none';
  return React.createElement("div", {
    className: classes.root,
    style: rootStyle,
    "data-testid": "contextual-toolbar"
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    className: classes.toolbar,
    wrap: "nowrap"
  }, React.createElement(Grid, {
    item: true,
    xs: true,
    className: cx(classes.left, classes.fullHeight),
    style: leftStyle
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    direction: "row",
    alignContent: "stretch",
    wrap: "nowrap"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement("div", {
    className: classes.iconWrapper,
    style: iconWrapperStyle
  }, React.createElement(Grid, {
    container: true,
    className: classes.fullHeight,
    alignItems: "center",
    justify: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Icon, iconProps))))), React.createElement(Grid, {
    item: true,
    xs: true,
    className: classes.leftTextWrapper
  }, React.createElement(Typography, {
    component: "div",
    noWrap: true,
    className: (classes.fullHeight, classes.textWrapper)
  }, leftChildren)))), React.createElement(Grid, {
    item: true,
    className: cx(classes.center, classes.fullHeight)
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    direction: "row",
    alignContent: "stretch",
    className: classes.fullHeight,
    wrap: "nowrap"
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    component: "div",
    className: classes.textWrapper
  }, center)))), React.createElement(Grid, {
    item: true,
    xs: true,
    className: cx(classes.right, classes.fullHeight)
  }, React.createElement(Grid, {
    container: true,
    alignItems: "center",
    direction: "row",
    alignContent: "stretch",
    className: classes.fullHeight,
    wrap: "nowrap"
  }, React.createElement(Grid, {
    item: true,
    xs: true
  }, React.createElement(Typography, {
    component: "div",
    className: classes.textWrapper
  }, rightChildren))))));
};

ToolBar.defaultProps = {
  leftChildren: null,
  centerChildren: null,
  centerTabs: null,
  rightChildren: null,
  color: null,
  'data-testid': 'toolbar'
};
export default ToolBar;